import { Savings } from 'pages/Asset/tabs/Cases/components/Savings/Savings';
import { useGetCaseOptionsQuery } from 'queries/cases/queries';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDatePicker, FormSelect } from 'ui/FormComponents';
import { FormComponentProps } from '../CaseFormStep/CaseFormStep';
import GoToStageBanner from '../GoToStageBanner/GoToStageBanner';
import { caseStatus } from 'queries/cases/types';
import { TextEditorWithLabel } from 'components/TextEditorWithLabel/TextEditorWithLabel';

export function FeedbackForm({
  isStepAble,
  isStepRequired,
  isPreviousStepFilled,
  onSubmit,
}: FormComponentProps) {
  const { t } = useTranslation();

  const { data: caseOptions } = useGetCaseOptionsQuery();

  const conclusionStatusOptions = useMemo(
    () =>
      caseOptions?.conclusion?.map((option) => ({
        value: option.toString(),
        label: t(`case:conclusion.${option}`, { defaultValue: option }),
      })) || [],
    [caseOptions, t],
  );
  const asteristic = isStepAble && !isStepRequired ? ' *' : '';

  return (
    <>
      {!isStepAble && (
        <GoToStageBanner
          stageName={caseStatus.feedback}
          onSubmit={onSubmit}
          shouldGo={isPreviousStepFilled}
        />
      )}
      <div className="columns is-variable is-2">
        <div className="column is-half">
          <FormSelect
            name="conclusion"
            isRequired={isStepRequired}
            disabled={!isStepAble}
            label={t('case:conclusion.label') + asteristic}
            placeHolderText={t('case:placeholders.selectAnOption')}
            selectOptionData={conclusionStatusOptions}
          />
        </div>

        <div className="column is-half">
          <FormDatePicker
            name="anomaly_end"
            label={t('case:inputs.anomaly_end') + asteristic}
            isRequired={isStepRequired}
            disabled={!isStepAble}
            dateFormat={t('formats:date.lts')}
          />
        </div>
      </div>

      <div className="columns">
        <div className="column is-full">
          <TextEditorWithLabel
            name="feedback_comments"
            label={t('case:placeholders.comments') + asteristic}
            isRequired={isStepRequired}
            isDisabled={!isStepAble}
            placeholder={t('case:records.feedback_comments')}
            data-testid="feedback_comments"
            onSubmit={onSubmit}
          />
        </div>
      </div>

      <div className="pt-4">
        <Savings />
      </div>
    </>
  );
}
